<template>
  <v-app style="background:#000000;color:#ffffff;">
    <Header style="background:#000000;color:#ffffff;"/>
    <v-content>
      <UnderConstruction />
      <!-- <HelloWorld/> -->
    </v-content>
  </v-app>
</template>
<style lang="scss" scoped>
.dark-mode {
  color: #ffffff;
  background:#000000;
}
</style>

<script>
// import HelloWorld from "./components/HelloWorld";
import Header from "./components/partials/Header";
import UnderConstruction from "./components/partials/UnderConstruction";

// Segment code
!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";
  analytics.load("sqkcgXd9OhpDBNbMWzostpfb39BmJxP0");
  analytics.page();
  }}();

export default {
  name: "App",
  components: {
    // HelloWorld,
    Header,
    UnderConstruction
  },
  data() {
    return {
      //
    };
  }
};
</script>
